export default __webpack_public_path__ + "static/media/2244.23894cb3.png";